import { useMemo } from 'react'
import { useIntl } from 'react-intl'

function useCarHireImportantInformationCategoryLabels(): Record<App.CarHireImportantInformationCategory, string> {
  const intl = useIntl()

  return useMemo(() => ({
    Inclusions: intl.formatMessage({
      id: 'lYAyvyPflKU549rNHma4',
      defaultMessage: 'Inclusions',
      description: 'Tab label for inclusions section in car hire details modal',
    }),
    Coverage: intl.formatMessage({
      id: 'tz2f-_TuYcTkJh-qaYhi',
      defaultMessage: 'Coverage',
      description: 'Tab label for coverage section in car hire details modal',
    }),
    'Driver & Vehicle': intl.formatMessage({
      id: 'RA-g9FKQfy9evg5Qf5PI',
      defaultMessage: 'Driver & Vehicle',
      description: 'Tab label for driver and vehicle section in car hire details modal',
    }),
    'Deposit & Payment': intl.formatMessage({
      id: 'z20nR69TtoKp2hGyoJsm',
      defaultMessage: 'Deposit & Payment',
      description: 'Tab label for deposit and payment section in car hire details modal',
    }),
    'Travel Restrictions': intl.formatMessage({
      id: 'NgLi-l8j02RbNLQ9w8Vs',
      defaultMessage: 'Travel Restrictions',
      description: 'Tab label for travel restrictions section in car hire details modal',
    }),
    Other: intl.formatMessage({
      id: 'GOI1Tfj8-4sZKLOW8jaU',
      defaultMessage: 'Other',
      description: 'Tab label for other information section in car hire details modal',
    }),
  }), [intl])
}

export default useCarHireImportantInformationCategoryLabels
